var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4333_4940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99984 1.16699C7.76587 1.16699 8.52444 1.31788 9.23214 1.61103C9.9399 1.90418 10.583 2.33386 11.1246 2.87553C11.6663 3.41721 12.096 4.06027 12.3891 4.76801C12.6823 5.47574 12.8332 6.23429 12.8332 7.00033M12.8332 7.00033C12.8332 7.92088 12.6153 8.82838 12.1974 9.6486C11.7794 10.4688 11.1734 11.1785 10.4286 11.7196L6.99984 7.00033V1.16699M6.99984 1.16699C3.77817 1.16699 1.1665 3.77866 1.1665 7.00033C1.1665 10.222 3.77817 12.8337 6.99984 12.8337C10.2215 12.8337 12.8332 10.222 12.8332 7.00033M6.99984 1.16699C10.2215 1.16699 12.8332 3.77867 12.8332 7.00033M12.8332 7.00033H6.99984",
    stroke: "#717182",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4333_4940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie_chart.650b00c793520fb08c8ba06f2d1150be.svg";
export { ForwardRef as ReactComponent };